import { getOssUploadUrl, kuaishouUploadReport } from '@/api/open'
import md5 from 'js-md5';

export default {
    components: {
    },
    model: {
        prop: 'url',
        event: 'change'
    },
    props: ['url', 'num', 'data', 'advertiser_id'],
    data() {
        return {
            maxNum: 1,
            headers: {},
            uploadUrl: '',
            loading: false,
            previewVisible: false,
            previewImage: '',
            fileList: [],
            type: 3, //类型： 2-图片 3-视频
            materials: [],
            types: [],
            urls: [],
            reportRes: {},
            reportList: [],
            showList: [],
        }
    },
    computed: {
    },
    watch: {
        url(value) {
            if (this.fileList.length > 0) {
                return
            }
            // console.log('urlwatch',value)
            const items = typeof (value) === 'string' ? [value] : value
            this.setUrl(items)
        },
        materials() {
            //同步主组件值
            this.$emit('afterUpload', this.materials);
            this.loading = false
            // console.log('qqqqqqqqqqqqqqqqqqqqqq:this.materials', this.materials)
        },
        reportList: {
            handler(items) {
                // console.log("reportList改变：", items)
                let urls = []

                const materials = []
                for (let i = 0; i < items.length; i++) {
                    let item = items[i]
                    const url = item.url
                    urls.push(url)

                    if (item.url) {
                        if (!Array.isArray(this.materials)) {
                            this.materials = []
                        }
                        materials.push(item)
                        this.types[`${item.url}`] = 3
                        this.showList[`${item.uid}`] = item
                    }
                }
                if (this.maxNum === 1) {
                    urls = urls[0]
                }
                // this.fileList = items
                this.materials = materials
                this.$emit('change', urls)
                // console.log('yyyyyyyyyyyyyyyyyyy', this.fileList)
            },
            deep: true
        }
    },
    mounted() {
        this.url && this.setUrl(this.url)
        this.maxNum = this.num || this.maxNum
        this.headers['Access-Token'] = localStorage.getItem('token')
    },
    methods: {
        handleCancel() {
            this.previewVisible = false
        },
        async handlePreview(file) {
            const thisFile = this.showList[file.uid]
            this.previewImage = thisFile.local_url
            this.previewVisible = true
        },
        handleChange({ fileList }) {
            // console.log('change',fileList)
            //此处改为fileList绑定
            this.fileList = fileList
            if (this.fileList.length <= 0) {
                this.materials = {}
            }
        },
        remove(item) {
            //移除reportList
            this.reportList = this.reportList.filter(obj => obj.uid !== item.uid);
        },
        beforeUpload(file) {
            this.loading = true
            let res
            let errorMessage = ''
            if (file.type.includes('image')) {
                this.type = 2
                const allowTypes = [
                    'image/jpg',
                    'image/jpeg',
                    'image/png',
                    'image/gif',
                ]

                const isImage = allowTypes.includes(file.type)
                if (!isImage) {
                    this.loading = false
                    errorMessage = '图片格式错误'
                    file.response = { code: -1, message: errorMessage }
                    this.$message.error(errorMessage);
                    return false
                }
                const isLt2M = file.size / 1024 / 1024 < 10

                if (!isLt2M) {
                    this.loading = false
                    errorMessage = '图片大小不能超过 10MB'
                    file.response = { code: -1, message: errorMessage }
                    this.$message.error(errorMessage);
                    return false
                }
                res = !!(isLt2M)
            } else {
                this.type = 3
                // file.response = { code: -1, message: '暂不支持视频' }
                // return false
                const isLt2M = file.size / 1024 / 1024 <= 2000;

                if (!isLt2M) {
                    this.loading = false
                    errorMessage = '视频大小不能超过 2000MB'
                    file.response = { code: -1, message: errorMessage }
                    this.$message.error(errorMessage);
                    return false
                }
                res = !!(isLt2M)
            }
            this.loading = true
            // console.log('res', res)
            if (res) {
                new Promise((resolve) => {
                    const reader = new FileReader();
                    reader.onload = () => {
                        const arrayBuffer = reader.result;
                        const md5 = this.calculateMD5(arrayBuffer);
                        resolve({ file, md5 });
                    };
                    reader.readAsArrayBuffer(file);
                });
            }
            this.loading = false
            return res

        },
        transformFile(file) {
            this.loading = true
            return new Promise((resolve) => {
                const reader = new FileReader();

                reader.onload = () => {
                    const transformedFile = file;

                    if (!file.md5) {
                        const arrayBuffer = reader.result;
                        const md5 = this.calculateMD5(arrayBuffer);
                        transformedFile.md5 = md5
                    }
                   
                    if (file.type.startsWith('image/')) {
                        const image = new Image();
                        image.onload = () => {
                            const width = image.width;
                            const height = image.height;
                            transformedFile.width = width;
                            transformedFile.height = height;
                            resolve(transformedFile);
                        };
                        // image.src = e.target.result;
                        image.src = URL.createObjectURL(file);
                    } else if (file.type.startsWith('video/')) {
                        const video = document.createElement('video');
                        video.onloadedmetadata = () => {
                            const width = video.videoWidth;
                            const height = video.videoHeight;
                            transformedFile.width = width;
                            transformedFile.height = height;
                            resolve(transformedFile);
                        };
                        // video.src = URL.createObjectURL(file);
                        video.src = URL.createObjectURL(file);
                    } else {
                        resolve(transformedFile);
                    }

                };
                reader.readAsArrayBuffer(file);
            });
        },
        customRequest({ file, onSuccess, onError, onProgress }) {

            this.loading = true
            //获取上传地址
            getOssUploadUrl({ name: file.name, type: this.type, md5: file.md5, 'upload_type': 'kuaishou', advertiser_id: this.advertiser_id }).then(res => {
                this.$message.destroy()
                if (!(res && res.code === 0)) {
                    this.loading = false
                    return this.$message.error(res.message)
                }

                let uploadUrl = res.data.url
                let upload_token = res.data.upload_token
                uploadUrl = "https://"+uploadUrl+'/api/upload/multipart?upload_token='+upload_token
                console.log('上传url', uploadUrl)

             

                // 创建 FormData 对象并添加文件数据
                let formData = new FormData();
                formData.append('file', file); // 将文件添加到 FormData 中
                
                //开始上传到快手
                const xhr = new XMLHttpRequest();
                xhr.open('POST', uploadUrl, true);
                // 设置请求头的 Content-Type
                this.loading = false

                // 上传进度回调
                xhr.upload.onprogress = (event) => {
                    if (event.lengthComputable) {
                        const percent = Math.floor((event.loaded / event.total) * 100);
                        onProgress({ percent });
                        this.fileList = this.fileList.map((item) =>
                            item.uid === file.uid ? { ...item, percent } : item
                        );
                    }
                };

                this.loading = true

                // 上传成功回调
                xhr.onload = () => {
                    if (xhr.status === 200) {
                        const responseText = JSON.parse(xhr.responseText)
                        // console.log('上传快手返回 responseText： ', responseText)
                        this.loading = true

                        //上报服务器，获取文件存储位置的标识
                        if (responseText.result == 1) {
                            kuaishouUploadReport({
                                advertiser_id: this.advertiser_id,
                                upload_token: upload_token,
                            }).then(res => {
                                // console.log('上报返回：',res, file)
                                if (res && res.code === 0) {
                                    this.loading = false
                                    let returnData = res.data

                                    this.reportList.push({
                                        uid: file.uid,
                                        name: file.name,
                                        status: 'done',
                                        blob_store_key: returnData.blob_store_key,
                                        advertiser_id: this.advertiser_id,
                                        upload_token: upload_token,
                                        md5: file.md5,
                                        url:returnData.blob_store_key,
                                        local_url: URL.createObjectURL(file),
                                    });
    
                                    this.fileList = this.fileList.map((item) =>
                                        item.uid === file.uid ? { ...item, status: 'done', url:returnData.blob_store_key } : item
                                    );

                                    // console.log('file',file)
                                    // console.log('this.reportList',this.reportList)
                                }
                            })
                            onSuccess()
                        } else {
                            this.loading = false
                            onError(new Error('上传失败'));
                        }
                      
                    } else {
                        this.loading = false
                        onError(new Error('上传失败'));
                    }
                };

                this.loading = false
                // 上传失败回调
                xhr.onerror = () => {
                    this.loading = false
                    onError(new Error('上传失败'));
                };

                // 发送请求
                xhr.send(formData);
                
            })
                

        },
        setUrl(items) {
            if (!items) {
                return
            }
            if (typeof (items) === 'string') {
                items = [items]
            }
            for (let i = 0; i < items.length; i++) {
                this.fileList.push({
                    uid: (new Date()).getTime() + i,
                    name: 'image.png',
                    status: 'done',
                    url: items[i],
                })
            }
        },
        calculateMD5(data) {
            // 计算文件的 MD5 值
            return md5(data)
        },
        clearFiles() {
            this.fileList = []
        },
    }
}
